import classNames from '@prague-digi/class-names'
import React from 'react'
import { BButton, BLink, BIcon } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import messages from '../../../../i18n'
import { SMS_VERIFY } from '../../../../constants/modals'

import { modalDialogActions, signingActions } from '../../../../redux'
import { FormInterface, intl, IntlInterface } from '../../../../hoc'
import { ReduxState } from '../../../../types'
import { SigningType } from '../../../../constants'

import styles from './styles.scss'

interface Props extends IntlInterface, FormInterface {
  className: string
  phoneNumber: any
  showClientInfoModal: any
  showModalDialog: any
}

export class Footer extends React.Component<Props> {
  continue = () => {
    this.props.setSigningType(SigningType.Scoring)
    this.props.showModalDialog(SMS_VERIFY)
  }

  render() {
    return (
      <div className={classNames(styles.footer, this.props.className)}>
        <div className={styles.step1}>
          <div className={styles.sendSmsCodeInfo}>
            <span className={styles.icon}>
              <BIcon name="info" />
            </span>
            <div>
              <div>
                {this.props.translate(messages.recapitulation.footer.sendSmsCodeInfo, {
                  phoneNumber: this.props.formatPhoneNumber(this.props.phoneNumber),
                })}
              </div>
              <BLink
                type="link"
                testid="changePhoneNumber"
                className={styles.changePhoneNumberBtn}
                onClick={this.props.showClientInfoModal}>
                <span className={styles.text}>
                  {this.props.translate(messages.recapitulation.footer.changePhoneNumber)}
                </span>
              </BLink>
            </div>
          </div>
          <div className={styles.continueBtnWrapper}>
            <BButton
              disabled={!this.props.phoneNumber}
              messages={{
                message: this.props.translate(messages.recapitulation.footer.continueBtn),
              }}
              onClick={this.continue}
              color="primary"
              size="lg"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  connect(
    (state: ReduxState) => ({
      phoneNumber: state.client.phoneNumber,
    }),
    {
      setSigningType: signingActions.setSigningType,
      showModalDialog: modalDialogActions.showModalDialog,
    }
  ),
  intl
)(Footer)
